<template>
  <div>
    <activity-flow-card
      card_title="Cobros"
      extra-class="bg-danger"
      :data="reportData"
      :map-data="{ title: 'Title', qty: 'Qty' }"
      :loading="loading"
      @click-item-qty="handleClickLink"
    >
    </activity-flow-card>

    <rabbey-base-drawer :drawer.sync="drawer" size="80%" :title="title">
      <CardStatDrawerHeader
        :itemQuantity="itemQuantity"
        :totalAmount="totalAmount"
        :totalInvoice="totalInvoice"
        :totalItems="dc"
        :Title="title"
      />

      <rabbey-toolbox :filterables="true" @filter-search="search = $event" />
      <rabbey-table3
        :data="items"
        :search="search"
        :columns="columns"
        :actions="actions"
        :stripe="true"
        @rtable-push-action="handlerAction"
      ></rabbey-table3>
    </rabbey-base-drawer>

    <!-- DRAWERS DE PROMESA DE PAGOS Y COMENTARIOS -->

    <!-- Renovacion de contratos -->

    <el-drawer
      title="Cambio de fecha de pago"
      :append-to-body="true"
      :before-close="handleClose"
      :visible.sync="formpayment"
      size="25%"
    >
      <hr />
      <el-container>
        <el-main>
          <el-row>
            <el-col>
              <el-form
                ref="form"
                label-width="120px"
                v-model="changeDateForm"
                label-position="top"
              >
                <el-form-item label-width="0" label="Contacto">
                  <el-select
                    v-model="changeDateForm.contactCode"
                    v-loading="loadingContacts"
                    placeholder="Contactos"
                    style="width: 100%"
                    @change="getContactNumber"
                  >
                    <el-option
                      style="width: 100%"
                      v-for="item in contacts"
                      :key="item.Code"
                      :label="item.FullName"
                      :value="item.Code"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-row>
                  <!-- 
                    En caso de que el formatter
                  -->
                  <el-col :span="12">
                    <el-form-item label="Teléfono:">
                      <span v-if="contactPhone"
                        ><a :href="`tel:${contactPhone}`">{{ contactPhone }}</a>
                      </span>
                      <span v-if="changeDateForm.contactCode && !contactPhone">
                        NO DISPONIBLE
                      </span>
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item label="Celular:">
                      <span v-if="contactCellphone"
                        ><a :href="`tel:${contactCellphone}`">{{
                          contactCellphone
                        }}</a></span
                      >
                      <span
                        v-if="changeDateForm.contactCode && !contactCellphone"
                      >
                        NO DISPONIBLE
                      </span>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item label-width="0" label="Fecha Original">
                  <el-date-picker
                    type="date"
                    placeholder="Fecha Original"
                    v-model="changeDateForm.currentdate"
                    disabled
                    style="width: 100%"
                  ></el-date-picker>
                </el-form-item>

                <el-form-item label-width="0" label="Nueva Fecha">
                  <el-date-picker
                    type="date"
                    placeholder="Nueva Fecha"
                    v-model="changeDateForm.newdate"
                    style="width: 100%"
                  ></el-date-picker>
                </el-form-item>

                <el-form-item label-width="0" label="Comentario">
                  <el-input
                    type="textarea"
                    :rows="4"
                    placeholder="Comentario respecto al cambio de fecha de pago"
                    v-model="changeDateForm.comment"
                    style="width: 100%"
                  ></el-input>
                </el-form-item>

                <el-form-item>
                  <el-button
                    type="primary"
                    @click="onSubmit"
                    :disabled="!isValid"
                    size="mini"
                    >Guardar cambios</el-button
                  >
                  <el-button @click="handleClose" size="mini"
                    >Cancelar</el-button
                  >
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </el-drawer>

    <el-drawer
      title="Comentarios"
      :visible.sync="comments"
      :append-to-body="true"
      size="60%"
    >
      <el-container>
        <el-main>
          <el-row>
            <el-col>
              <rabbey-table3
                ref="table2"
                :columns="columnsComments"
                v-loading="loadingDetails"
                :before-close="handleClose"
                :data="commentList"
              />
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </el-drawer>
  </div>
</template>

<script>
import { Decimal } from "decimal.js";
import axios from "axios";
import ActivityFlowCard from "@/components/activity_flow/ActivityFlowCard.vue";
import { penddingPaymentColumns } from "@/columns";
import { COLUMNAS, ACTIONS } from "@/columns/requestColumns";
import { helperGetColumsItems } from "./utils.js";
import CardStatDrawerHeader from "./CardStatDrawerHeader.vue";
import { commentColumns } from "@/helpers/MonthsColumns";
import { formatPhoneNumber } from "@/utils";
// import { COLUMNAS } from "@/views/modules/technical_support/requests/requests.js";

export default {
  name: "ChargesStat",
  props: {
    employee: {
      type: [String, Number]
    },
    refreshStat: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ActivityFlowCard,
    CardStatDrawerHeader
  },
  created() {
    this.getReportData();
  },
  data() {
    return {
      reportData: [],
      loading: false,
      title: "",
      dialogVisible: false,
      drawer: false,
      search: "",
      columns: [],
      items: [],
      EntryNoIndex: "",
      ContractsRenovationKey: 0,
      itemQuantity: 0,
      totalAmount: 0,
      totalInvoice: 0,
      dc: {
        10: { Cantidad: 0, Monto: 0, Class: "Naranja" },
        12: { Cantidad: 0, Monto: 0, Class: "Rojo" },
        13: { Cantidad: 0, Monto: 0, Class: "Rojo" },
        15: { Cantidad: 0, Monto: 0, Class: "Rojo" },
        17: { Cantidad: 0, Monto: 0, Class: "Rojo" },
        25: { Cantidad: 0, Monto: 0, Class: "Azul" },
        30: { Cantidad: 0, Monto: 0, Class: "Verde" }
      },
      request: null, // cancelation token
      mapColumns: {
        PeddingInvoices: penddingPaymentColumns,
        PeddingInvoicesOnTime: penddingPaymentColumns,
        PeddingInvoicesLateOneMonthOrLess: penddingPaymentColumns,
        PeddingInvoicesLateBetweenOneAndTwoMonths: penddingPaymentColumns,
        PeddingInvoicesLateOverTwoMonths: penddingPaymentColumns,
        NoPromisedPaymentDate: penddingPaymentColumns,
        ContractReview: COLUMNAS,
        InventoryUpdate: COLUMNAS
      },

      //DATA DE CAMBIO DE PROMESA DE PAGO
      actions: [
        {
          icon: "el-icon-date",
          label: "Cambiar fecha de pago",
          command: "change-date-payment"
        },
        {
          icon: "el-icon-chat-line-square",
          label: "Ver comentario",
          command: "see-comments"
        }
      ],
      actionsNews: ACTIONS,

      formpayment: false,
      comments: false,
      loadingContacts: false,
      loadingDetails: false,

      changeDateForm: {
        currentdate: "",
        newdate: "",
        comment: "",
        contactCode: ""
      },

      Amount: 0,
      AccountNumber: 0,
      invoiceNum: 0,
      OldDate: "",
      contactPhone: 0,
      contactCellphone: 0,

      contacts: [],
      commentList: [],
      columnsComments: [...commentColumns]
    };
  },
  methods: {
    getReportData() {
      if (this.request) {
        this.request.cancel();
      }
      const axiosSource = axios.CancelToken.source();
      this.request = { cancel: axiosSource.cancel };

      this.loading = true;
      this.$http
        .get("/api/MessageApi/GetCollectionStat", {
          cancelToken: axiosSource.token,
          timeout: 3 * 60 * 1000,
          params: {
            CompanyCode: this.currentCompany,
            UserName: this.currentUser.UserName,
            EmployeeId: this.employee,
            PersonCode: this.currentUser.PersonCode
          }
        })
        .then((resp) => {
          this.reportData = resp.data;
          this.loading = false;
        })
        .catch((error) => console.error(error));
    },
    handleClickLink(props) {
      // console.log(props);
      const report = this.reportData.find((f) => f.Title === props.title);
      const { items, columns } = helperGetColumsItems(report, this.mapColumns);
      this.items = items;
      this.columns = columns;
      this.title = props.title;
      this.drawer = true;

      this.totalAmount = props.qty; // Gets total items to display it on the header of the drawer
      this.itemQuantity = this.items.length; // Gets total items to display it on the header of the drawer
      this.totalInvoice = this.items.length;

      this.dc = {
        //These is for when a new call is made the dictionary start with the data at 0
        10: { Cantidad: 0, Monto: 0, Class: "Naranja" },
        12: { Cantidad: 0, Monto: 0, Class: "Rojo" },
        13: { Cantidad: 0, Monto: 0, Class: "Rojo" },
        15: { Cantidad: 0, Monto: 0, Class: "Rojo" },
        17: { Cantidad: 0, Monto: 0, Class: "Rojo" },
        25: { Cantidad: 0, Monto: 0, Class: "Azul" },
        30: { Cantidad: 0, Monto: 0, Class: "Verde" }
      };

      items.forEach((item) => {
        //obtaining the number of days and amounts
        this.dc[item.DayInvoice].Cantidad += 1;
        this.dc[item.DayInvoice].Monto = new Decimal(
          this.dc[item.DayInvoice].Monto
        )
          .plus(item.Amount)
          .toNumber();
      });

      // for (let i = 0; i < items.length; i++) {
      //   this.dc[items[i].DayInvoice].Cantidad += 1;
      //   this.dc[items[i].DayInvoice].Monto += 2;
      // }
    },
    handlerAction(action) {
      const { command } = action;
      const { CustomerNo, PostingDate, DocumentNo, EntryNo } = action.row;
      this.Amount = action.row.Amount;
      this.AccountNumber = CustomerNo;
      this.invoiceNum = DocumentNo;
      this.OldDate = PostingDate;
      switch (command) {
        case "change-date-payment":
          this.formpayment = true;
          this.changeDateForm.currentdate = PostingDate;
          this.getContactsByCustomerCode(CustomerNo);
          this.EntryNoIndex = EntryNo;
          break;

        case "see-comments":
          this.comments = true;
          this.getcomments(CustomerNo);
          break;

        default:
          break;
      }
    },
    getContactsByCustomerCode(customerCode = String) {
      this.loadingContacts = true;
      this.$http
        .get("/api/contacts/GetContactByCustomerCode", {
          params: {
            customerCode: customerCode,
            companyCode: this.currentCompany
          }
        })
        .then(({ data }) => {
          this.contacts = data;
        })
        .catch((err) => {
          this.$message.error(
            `no se pudieron tener contacto sobre este cliente ${err}`
          );
        })
        .finally(() => {
          this.loadingContacts = false;
        });
    },
    getcomments(customerCode) {
      let parameters = {
        CustomerCode: customerCode,
        CompanyId: this.currentCompany
      };
      this.commentloading = true;
      this.$http
        .get("/api/interactions/InteractionsCustomerDetails", {
          params: parameters
        })
        .then((response) => {
          response.data.Items.forEach((row) => {
            if (row.Description) {
              const cleanComment = row.Description.replace(/(<([^>]+)>)/gi, "");
              row.Description = cleanComment;
            }
          });
          this.prospectDetailInteractions = response.data.Items;
          this.commentList = response.data.Items;
        })
        .finally(() => {
          this.commentloading = false;
        });
    },
    onSubmit() {
      var data = {
        OldDate: this.changeDateForm.currentdate,
        PromiseDate: this.changeDateForm.newdate,
        Motive: this.changeDateForm.comment,
        CustomerCode: this.AccountNumber,
        Amount: this.Amount,
        InvoiceNum: this.invoiceNum,
        ContactEmail: "",
        ContactNumber: this.changeDateForm.contactCode,
        CompanyID: this.currentCompany,
        SalesPersonCode: this.currentUser.PersonCode,
        CustomerServiceExec_: this.currentUser.CustomerServiceExec_
      };
      this.$http
        .post("/api/AccountsReceivable/ChangeDataFromDueDateToFutureDate", data)
        .then(({ data }) => {
          if (data) {
            this.formpayment = false;
            if (data.AddInteraction) {
              let msg =
                "Se ha creado una interacion con este compromiso de pago";
              setTimeout(() => {
                this.$notify.success({
                  duration: 9000,
                  message: msg,
                  title: "Creacion de Interacion",
                  position: "top-left"
                });
              }, 1500);
            }
            if (data.NotifyCustomer) {
              let msg = "El contacto ha sido notificado via correo";
              setTimeout(() => {
                this.$notify.success({
                  duration: 9000,
                  message: msg,
                  offset: 10,
                  title: "Notificacion a cliente",
                  position: "top-left"
                });
              }, 1500);
            }
            if (data.CashFlowModify) {
              let msg =
                "Se ha creado un movimiento en cashflow con este compromiso";
              setTimeout(() => {
                this.$notify.success({
                  duration: 9000,
                  message: msg,
                  offset: 20,
                  title: "Registro en cashflow",
                  position: "top-left"
                });
              }, 1500);
            }
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.handleClose();

          const PromiseIndex = this.items.findIndex(
            (promise) => promise.EntryNo == this.EntryNoIndex
          );
          this.items.splice(PromiseIndex, 1);
        });
    },
    handleClose() {
      this.changeDateForm.currentdate = "";
      this.changeDateForm.newdate = "";
      this.changeDateForm.comment = "";
      this.changeDateForm.contactName = "";
      this.changeDateForm.contactEmail = "";
      this.changeDateForm.contactNumber = "";
      this.changeDateForm.contactPhoneNumber = "";
      this.AccountNumber = "";
      this.Amount = "";
      this.InvoiceNum = "";
      this.ContactEmail = "";
      this.formpayment = false;
      this.selectedRow = {};
    },
    getContactNumber(contactCode) {
      var contact = this.contacts.find((c) => c.Code == contactCode);
      this.contactPhone = formatPhoneNumber(contact.PhoneNumber);
      this.contactCellphone = formatPhoneNumber(contact.MobilePhoneNumber);
    }
  },
  computed: {
    isValid: function () {
      return (
        this.changeDateForm.comment.trim().length > 5 &&
        this.changeDateForm.newdate !== null
      );
    }
  },
  watch: {
    refreshStat() {
      this.getReportData();
    },
    employee() {
      this.getReportData();
    }
  }
};
</script>

<style></style>
